import { render, staticRenderFns } from "./MediaPostCreateView.vue?vue&type=template&id=077a60c6&scoped=true&"
import script from "./MediaPostCreateView.vue?vue&type=script&lang=ts&"
export * from "./MediaPostCreateView.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPostCreateView.vue?vue&type=style&index=0&id=077a60c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a60c6",
  null
  
)

export default component.exports